module.exports = __webpack_public_path__ + "static/img/background.5581ad8d.png";